<div class="crm-read-only-container" *ngIf="readOnly; else formField">
  <div class="crm-field-label">{{ label | translate }}</div>
  <div class="crm-field-value">
    <!-- ng-container necessary since Angular interpolation will add empty space -->
    <ng-container *ngIf="control.value"> {{ control.value | glxyCurrency: displayedCurrencyCode() }}</ng-container>
  </div>
</div>
<ng-template #formField>
  <glxy-currency-field
    [formControl]="control"
    [currencyCode]="displayedCurrencyCode()"
    [placeholder]="'MODEL_DRIVEN_FORM.ADD_FIELD_VALUE' | translate: { fieldName: label.toLowerCase() }"
    [label]="label | translate"
    [maximumValue]="'100000000'"
    [minimumValue]="'-100000000'"
    (keydown.enter)="$event.preventDefault()"
  >
    <crm-model-driven-form-error
      glxyError
      [objectType]="objectType"
      [fieldId]="fieldId"
      [label]="label"
      [control]="control"
      [validation]="validation"
    ></crm-model-driven-form-error>
  </glxy-currency-field>
</ng-template>
